module.exports = __webpack_public_path__ + "img/horizontal_2_1_9005.649d6ead.png";